import React, { FC } from 'react'

import { IconArrowUpProps } from './IconArrowUp.types'
import * as Styled from './styles/IconArrowUp.style'

import { nonThemeableRules } from '../../ruleSet'

const IconArrowUp: FC<IconArrowUpProps> = ({
  size = nonThemeableRules.defaultSize as number as IconArrowUpProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconArrowUpProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='m150.83 69.17-68-68a4 4 0 0 0-.6-.49c-.1-.07-.21-.11-.31-.17a3.94 3.94 0 0 0-.38-.2 3.94 3.94 0 0 0-.4-.12c-.12 0-.23-.08-.35-.1A4 4 0 0 0 80 0h-.1a4 4 0 0 0-.73.07c-.12 0-.23.07-.35.1a3.94 3.94 0 0 0-.39.12 4 4 0 0 0-.38.2c-.1.06-.21.1-.31.17a4 4 0 0 0-.56.46h-.05l-68 68a4 4 0 0 0 5.66 5.66L76 13.66V156a4 4 0 0 0 8 0V13.66l61.17 61.17a4 4 0 0 0 5.66-5.66z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconArrowUp
